<!-- dient als Platzhalter, wenn eine leer Fläche erzeugt werden soll-->
<template>
  <div></div>
</template>
<script setup>
  console.log("filler initialized :)")
</script>
